import React, { useContext } from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';

import EnvironmentContext from '../../../contexts/EnvironmentContext';
import getStaticImageUrl from '../../../utils/getStaticImageUrl';

import Classes from './AdmarktRegistrationStepCustomerRecommend.scss';

type AdmarktRegistrationStepCustomerRecommendProps = {
  recommendName: string;
  imgSrc: string;
  customerImgSrc: string;
  comment: string;
  activeSlide: number;
  index: number;
};
const AdmkartRegistrarionStepCustomerRecommend = ({
  recommendName,
  comment,
  imgSrc,
  customerImgSrc,
  index,
  activeSlide,
}: AdmarktRegistrationStepCustomerRecommendProps) => {
  const { staticBaseUrl } = useContext(EnvironmentContext);

  return (
    <div className={Classes.slide} id={`slide${index}`} data-active={activeSlide === index ? 'active' : undefined}>
      <div className={Classes.imageContainer}>
        <img
          className={Classes.recommendImage}
          src={getStaticImageUrl(staticBaseUrl, customerImgSrc)}
          alt="recommend-person"
        />
        <img className={Classes.recommendIcon} src={getStaticImageUrl(staticBaseUrl, imgSrc)} alt="recommend-sign" />
      </div>
      <div className={Classes.recommendationTextBlock}>
        <Trans tagName="p" i18nKey={comment} className={Classes.commentText} />
        <Trans tagName="strong" i18nKey={recommendName} />
      </div>
    </div>
  );
};

export default AdmkartRegistrarionStepCustomerRecommend;
